import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import { Navigate } from "react-router-dom";
import Footer from "./components/Footer";

const Home = lazy(() => import("./components/Home"));
const Introduction = lazy(() => import("./components/Introduction"));
const Modules = lazy(() => import("./components/Modules"));
const KeyFeatures = lazy(() => import("./components/KeyFeatures"));
const UseCases = lazy(() => import("./components/UseCases"));
const Comparison = lazy(() => import("./components/Comparison"));
const Contact = lazy(() => import("./components/Contact"));
const RoleBased = lazy(() => import("./components/RoleBased"));
const SecureDataTransfer = lazy(() => import("./components/SecureDataTransfer"));
const AdvancedMultiDocumentConversion = lazy(() => import("./components/AdvancedMultiDocumentConversion"));
const AgeBasedArchival = lazy(() => import("./components/AgeBasedArchival"));
const DataMigrationModule = lazy(() => import("./components/DataMigrationModule"));
const FAQPage = lazy(() => import("./components/FAQPage"));
const FeatureDetail = lazy(() => import("./components/FeatureDetail")); // Add this line

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/introduction" element={<Introduction />} />
          <Route path="/modules" element={<Modules />} />
          <Route path="/key-features" element={<KeyFeatures />} />
          <Route path="/use-cases" element={<UseCases />} />
          <Route path="/comparison" element={<Comparison />} />
          <Route path="/role-based-access" element={<RoleBased />} />
          <Route path="/secure-data-transfer" element={<SecureDataTransfer />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/multi-document-conversion" element={<AdvancedMultiDocumentConversion />} />
          <Route path="/age-based-archival" element={<AgeBasedArchival />} />
          <Route path="/data-migration" element={<DataMigrationModule />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/feature/:id" element={<FeatureDetail />} />
          <Route path="/login" element={<Navigate to="https://main.dcjhso1bgs7vu.amplifyapp.com/" replace />} />

        </Routes>
      </Suspense>
      <Footer />
    </Router>
  );
};

export default App;